import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    briefOriginalId: 0,
    fechaRegistro: '1900-01-01',
    usuario: '',
    cambios: '',
    fechaSolucion: '1900-01-01',
    usuarioSolucion: '',
    solucionado: false
};

const mutations = {
    updateField,

    'SET_BRIEF_ORIGINAL_CAMBIOS'(state, briefOriginalCambios) {
        state.id = briefOriginalCambios.id;
        state.briefOriginalId  = briefOriginalCambios.briefOriginalId;
        state.fechaRegistro = moment(new Date()).format('YYYY-MM-DD HH:mm');
        state.usuario = briefOriginalCambios.usuario;
        state.cambios = briefOriginalCambios.cambios.trim();
        state.fechaSolucion = '1900-01-01';
        state.usuarioSolucion = '';
        state.solucionado = false;
    },    
};

const getters = {
    getField,

    briefOriginalCambios (state) {
        return {
            id: state.id,
            briefOriginalId: state.briefOriginalId,
            fechaRegistro: state.fechaRegistro,
            usuario: state.usuario.trim(),
            cambios: state.cambios.trim(),
            fechaSolucion: state.fechaSolucion,
            usuarioSolucion: state.usuarioSolucion.trim(),
            solucionado: state.solucionado
        }
    }
};

const actions = {
    addValidacionTecnica ( {}, params ) {
        return new Promise((resolve, reject) => {
            let validacion = {
                observaciones: params.observaciones
            }

            apiAxios.post(`briefs/${params.briefId}/originales/${params.briefOriginalId}/validacion-tecnica/add`, validacion)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    addValidacionInformacion ( {}, params ) {
        return new Promise((resolve, reject) => {
            let validacion = {
                observaciones: params.observaciones,
                especificaciones: params.especificaciones
            }

            apiAxios.post(`briefs/${params.briefId}/muestras/${params.briefMuestraId}/validacion-informacion/add`, validacion)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    addEspecificacionesMuestra ( {}, params ) {
        return new Promise((resolve, reject) => {
            let especificaciones = {
                observaciones: params.especificaciones
            }

            apiAxios.post(`briefs/${params.briefId}/muestras/${params.briefMuestraId}/especificaciones`, especificaciones)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    addSolicitudCambios ( { commit, rootState }, params ) {
        return new Promise((resolve, reject) => {
            let cambios = {
                observaciones: params.observaciones
            }

            let usuario = '';
            if (rootState.user) {
                if (rootState.user.nombreCompleto) {
                    usuario = rootState.user.nombreCompleto.trim();
                }
            }

            apiAxios.post(`briefs/${params.briefId}/originales/${params.briefOriginalId}/cambios/add`, cambios)
                .then(res => {
                    params.id = res.data.id;
                    params.usuario = usuario.trim();
                    params.cambios = params.observaciones;

                    commit('SET_BRIEF_ORIGINAL_CAMBIOS', params);
                    
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    deleteSolicitudCambios ( {}, params ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`briefs/${params.briefId}/originales/${params.briefOriginalId}/cambios/${params.solicitudCambiosId}/delete`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    solucionarSolicitudCambios ( {}, params ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`briefs/${params.briefId}/originales/${params.briefOriginalId}/cambios/${params.solicitudCambiosId}/solucionar`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}